import React from 'react'

const Error = () => {
    return (
        <div id="search" className="invalid-feedback">
            Debe ingresar algo para realizar la busqueda
        </div>
    )
}

export default Error;
